import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import IEsiaResponse from '../models/interfaces/IEsiaResponse';
import { IAccountOrganizationDto, IChooseActorRequest } from '../models/interfaces/IAccountOrganizationDto';
import { AppsettingsConfig } from '../../client-config/models/client-config';
import { IAccountStrangeOrganizationDto, IChooseActorStranger } from '../models/interfaces/IAccountStrangeOrganizationDto';

@Injectable({
  providedIn: 'root',
})
export class ChooseActorService {
  backendUrl;

  constructor(
    private http: HttpClient,
    private appsettings: AppsettingsConfig
  ) {
    this.backendUrl = appsettings.backendUrl;
  }

  changeUserOrg(actor: IChooseActorRequest): Observable<HttpResponse<IEsiaResponse>> {
    return this.http.post<IEsiaResponse>(`${this.backendUrl}/account/change-user-org`, actor, { observe: 'response' });
  }

  getUserOrgs(): Observable<IAccountOrganizationDto[]> {
    return this.http.get<IAccountOrganizationDto[]>(`${this.backendUrl}/oauth/UserOrgs`);
  }

  getStrangerOrgs(): Observable<IAccountStrangeOrganizationDto[]> {
    return this.http.get<IAccountStrangeOrganizationDto[]>(`${this.backendUrl}/oauth/stranger-orgs`)
  }

  changeStrangerOrg(actor: IChooseActorStranger): Observable<IEsiaResponse> {
    return this.http.post<IEsiaResponse>(`${this.backendUrl}/oauth/stranger-orgs`, actor);
  }
}
